import React from 'react'

import DashboardLayout from "../../layouts/DashboardLayout"


import BoardLayout from "../../layouts/BoardLayout"

const WeatherMapView = React.lazy(() => import("../../WeatherMapView"))
const ControlPanel = React.lazy(() => import("../../ControlPanelView"))
const WeatherView = React.lazy(() => import("../../WeatherView"))
const NewsFeedView = React.lazy(() => import("views/NewsFeedView"))
const DisasterMapView = React.lazy(() => import("../../DisasterMapView"))

const DisasterView = () => {

    return (
        <DashboardLayout mode={"disaster"}>
            <DashboardLayout.TopLeftView>
                <WeatherMapView/>
            </DashboardLayout.TopLeftView>
            <DashboardLayout.BottomLeftView>
                <ControlPanel mode={"disaster"}/>
            </DashboardLayout.BottomLeftView>
            <DashboardLayout.TopRightView>
                <WeatherView/>
            </DashboardLayout.TopRightView>
            <DashboardLayout.BottomRightView>
                <NewsFeedView/>
            </DashboardLayout.BottomRightView>
            <DashboardLayout.MainView>
                <BoardLayout>
                    <DisasterMapView/>
                </BoardLayout>
            </DashboardLayout.MainView>
        </DashboardLayout>
    )
}

export default DisasterView